$(document).ready(function () {

    $(document).on('click', '.js_tour-edit-calculation', tourCalculation);
    $(document).on('click', '.js_tour-edit-forced', tourEditForced);
    $(document).on('click', '.js_input_is_call', OrderInputIsCall);
    $(document).on('click', '.js_admin_send_actual_sms', OrderSendActualSms);
    $(document).on('click', '.js_admin_call', CallClient);
    $(document).on('click', '#print_page', PrintPageTour);
    $(document).on('click', '#print_doc_users', PrintDocUsers);
    $(document).on('click', '#print_doc', PrintDocTour);
    $(document).on('click', '#print_page_reverse', PrintPageTourReverse);
    $(document).on('change', '.station_from_time', setTimeFrom);
    $(document).on('change', '.js_city_from_id', CityFrom);
    $(document).on('focusout', '.js_input_order_price', ChangePrice);
    $(document).on('change', '.js_all_dates', allDates);
    $(document).on('change', '.js_only_visible', onlyVisible);
    $(document).on('click', '.js_mass_change_price', massChangePrice);
    $(document).on('click', '.js_copy_to_clipboard', copyToClipboard);
    $(document).on('click', '.js_copy_to_clipboardText', copyToClipboardText);
    $(document).on('click', '.js_copy_to_clipboardImage', copyToClipboardImage);
    function ChangePrice() {
        let id = $(this).data('order_id');
        let url = $(this).data('url');
        let price = $(this).val();

        $.get(url + '?id=' + id + '&price=' + price, (response) => {
            console.log(response);
            if (response.message != '') toastr.success(response.message);
        });
    }

    function CityFrom() {
        let url = $(this).data().url;
        let value = $(this).val();
        $(".js_city_to_id option").remove();
        $('.js_city_to_id').prop('disabled', false);

        $.get(url + '?city_from_id=' + value, (response) => {
            $('.js_city_to_id').append($('<option>', {
                value: '',
                text: '-Куда-'
            }));

            for (var key in response) {
                $('.js_city_to_id').append($('<option>', {
                    value: response[key].id,
                    text: response[key].name
                }));
            }
        })
        ;
    }

    function CallClient() {
        $.get($(this).data('url') + '?phone=' + $(this).data('phone'), (response) => {
            var Type = response.type;
            if (response.type === 'error') {
                toastr.error(toastr.error);
            } else {
                toastr.success('звонок сгенерирован');
            }
        });
    }

    function OrderSendActualSms() {
        let order_id = $(this).data('id');
        let url = $(this).data('url');
        let count_sms = $('.js_order_row_' + order_id).find('.js_count_sms').html();

        count_sms = parseInt(count_sms) + 1;
        $('.js_order_row_' + order_id).find('.js_count_sms').text(count_sms);
        $.get(url + '?id=' + order_id, (response) => {
            toastr.success('смс отправлена');
        });
    }


    function setTimeFrom() {
        let url = $(this).data('url');
        let id = $(this).data('id');
        let station_from_time = $(this).val();

        $.get(url + '?id=' + id + '&station_from_time=' + station_from_time, (response) => {
            if (response.result == 'success') {
                toastr.success(response.message);
            } else {
                toastr.error('что-то пошло не так');
            }
        });
    }

    function dump(obj) {
        var out = '';
        for (var i in obj) {
            out += i + ": " + obj[i] + "\n";
        }

        alert(out);

        // or, if you wanted to avoid alerts...

        var pre = document.createElement('pre');
        pre.innerHTML = out;
        document.body.appendChild(pre)
    }

    function OrderInputIsCall() {

        let value = 0;
        let id = $(this).attr('id');
        let url = $(this).attr('url');
        let phone = $(this).attr('phone');
        if ($(this).is(':checked')) value = 1;
        $.get(url + '?id=' + id + '&is_call=' + value + '&phone=' + phone, (response) => {
            if (response.result == 'success') {
                toastr.success(response.message);
            } else {
                toastr.error('что-то пошло не так(');
            }
        });
    }

    function tourCalculation() {
        let $calculation = $('[name=calculation]');
        $calculation.val(1);
        $('.js_tours-from').submit()
        $calculation.val(0);
    }

    function tourEditForced() {
        $('.js_tours-from').append('<input type="hidden" name="action" value="forceEdit" />');
        $('.js_tours-from').submit();
        $('input[value=forceEdit]').remove();
    }

    $('#popup_tour-edit,#auto_call_tour-edit').on('show.bs.modal', function (e) {
        let $button = $(e.relatedTarget)
        let url = $button.data('url')
        $.get(url, (response) => {
            $(this
            ).find('.modal-content').html(response.html)
            window.init()
        })
    })

    $('#popup_rent-edit').on('show.bs.modal', function (e) {
        let $button = $(e.relatedTarget)
        let url = $button.data('url')
        $.get(url, (response) => {
            $(this
            ).find('.modal-content').html(response.html);
            $('.js-select-search-single').select2({
                width: "100%",
            });
            window.init()
        })
    })

    $(document).on('hidden.bs.modal', function (e) {
        $(this).find('.modal-content').html('')
    });

    function PrintPageTour() {
        var printWindow = window.open(window.location.href + '/print');
        printWindow.addEventListener('load', function () {
            printWindow.print();
            // printWindow.close();
        }, true);

    }

    function PrintDocUsers() {
        var printWindow = window.open(window.location.href + '/doc_users/print');
        printWindow.addEventListener('load', function () {
            printWindow.print();
            // printWindow.close();
        }, true);
    }

    function PrintDocTour() {
        var printWindow = window.open(window.location.href + '/doc/print');
        printWindow.addEventListener('load', function () {
            printWindow.print();
            // printWindow.close();
        }, true);
    }

    function PrintPageTourReverse() {
        var printWindow = window.open(window.location.href + '/print/reverse');
        printWindow.addEventListener('load', function () {
            printWindow.print();
            // printWindow.close();
        }, true);

    }

    function countPull() {
        if ( $('.js_pull-count').length ) {
            $.get('/admin/pulls/count', (response) => {
                $('.js_pull-count').html(response.view);
            })
        }
    }

    function countCall() {
        if ( $('.js_pull-count_call').length ) {
            $.get('/admin/telphin/count', (response) => {
                $('.js_pull-count_call').html(response.view);
            })
        }
    }

    function countNotification() {
        if ( $('.js_noti-count').length ) {
            $.get('/admin/notifications/count', function (response) {
                $('.js_noti-count').html(response.view);
            });
        }
    }

    function allDates() {
        $('#all_dates').val($(this).prop('checked') ? 1 : 0);
        $('#all_dates').prop('disabled', $(this).prop('checked') ? false : true);
        $('.js_table-search').submit();
    }

    function onlyVisible() {
        $('#only_visible').val($(this).prop('checked') ? 1 : 0);
        $('#only_visible').prop('disabled', $(this).prop('checked') ? false : true);
        $('.js_table-search').submit();
    }

    function massChangePrice(e) {
        e.preventDefault();
        let $link = $(this);
        var dialog = bootbox.prompt({
            title: $link.data('title'),
            placeholder: $link.data('placeholder'),
            message: "<p>Внимание, будет изменена цена всех отображаемых рейсов!<br><br></p>",
            size: "large",

            callback: function (result) {
                if (result !== null && $.isNumeric(result))    {
                    $('#mass_price_update').prop('disabled', false);
                    $('#mass_price_update').val(result);
                    $('.js_table-search').submit();
                    $('#mass_price_update').prop('disabled', true);
                }
            }
        });
        return false;
    }

    function copyToClipboard(e) {
        e.preventDefault();
        let copyText = $(this).data('text');
        navigator.clipboard.writeText(copyText).then(function() {
            toastr.success('Данные успешно скопированы в буфер обмена');
        }, function(err) {
            toastr.success('Данные не скопированы: '+ err);
        });
    }

    function copyToClipboardText(e) {
        e.preventDefault();
        let text = $(this).closest('.popper-menu').find('.popper-menu-heading__content').clone();

        text.find('.no-copy').remove();

        navigator.clipboard.writeText(text.text()).then(function() {
            toastr.success('Данные успешно скопированы в буфер обмена');
        }, function(err) {
            toastr.success('Данные не скопированы: '+ err);
        });
    }

    function copyToClipboardImage(e) {
        e.preventDefault();
        let img = $(this).closest('.popper-menu').find('.popper-menu-heading__image');

        const imageBlob = createImageBlob(img.attr('src'));
        const item = new ClipboardItem({
            "image/png" : imageBlob,
        });

        navigator.clipboard.write([item]).then(function() {
            toastr.success('Данные успешно скопированы в буфер обмена');
        }, function(err) {
            toastr.success('Данные не скопированы: '+ err);
        });
    }

    async function createImageBlob(imageURL) {
        const img = new Image;
        const c = document.createElement("canvas");
        const ctx = c.getContext("2d");
        img.crossOrigin = "";
        img.src = imageURL;
        return new Promise(resolve => {
          img.onload = function () {
            c.width = this.naturalWidth;
            c.height = this.naturalHeight;
            ctx.drawImage(this, 0, 0);
            c.toBlob((blob) => {
              // here the image is a blob
              resolve(blob)
            }, "image/png", 0.75);
          };
        })
      }

    countPull();
    countCall();
    countNotification();

    setInterval(function () {
        return countPull();
    }, 100000);
    setInterval(function () {
        return countCall();
    }, 100000);

    window.countPull = countPull;
    window.countCall = countCall;
    window.countNotification = countNotification;
$(document).on('click','.click-comment',function(){
let id=$(this).data('id');
    $('#modal_id').val(id);
    let comment=$('.comment'+id).data('comment');
    $('.formcomment_id').val(comment);
     $("#calledmodaltelphin").modal('show');
});



    $(document).on('click','.btn-telphim-miss-submit',function(){
     $("#calledmodaltelphin").modal('hide');
    let  id= $('#modal_id').val();
    $.ajax({
    method:'POST',
    url:'/admin/telphin/savestatus',
    data:{
    id:$('#modal_id').val(),
    comment:$('.formcomment_id').val(),
    type:'comment',
    },
    success:function(data){
    if(data.comment==''){
   $('.comment'+id).html(' <i class="fa fa-plus btn btn-sm btn-primary"></i>');
    }else{
    $('.comment'+id).html('<i class="fa fa-edit"></i> '+data.comment);
    }

$('.comment'+id).data('comment',data.comment);
$('.formcomment_id').val('');

    }
    })
return false;

    });
     $(document).on('click','.click_call_check',function(){
$('.wrapper-spinner').show();
    let  id= $(this).data('id');
    $.ajax({
    method:'POST',
    url:'/admin/telphin/savestatus',
    data:{
    id:id,
    type:'status',
    },
    success:function(data){
    $('.wrapper-spinner').hide();
    if(data.called==1){
   $('.called'+id).html(' <a href="#" class="click_call_check" data-called="1" data-id="'+id+'"> <i class="fa fa-check"></i></a>');
    }else{
    $('.called'+id).html('<a href="#" class="click_call_check" data-called="0" data-id="'+id+'"> <i class="fa fa-edit"></i></a>');
    }



    }
    })

return false;
    })
    $(document).on('click','.open_modal_call', function (e) {
        $('#auto_call_tour-edit').modal('show');

        let url = $(this).data('url')
        $.get(url, (response) => {
            $('#auto_call_tour-edit').find('.modal-content').html(response.html)
            window.init()
        })
    })

})
